import Vue from 'vue'
import Vuex, {} from 'vuex'
import { VuexPersistence } from 'vuex-persist'

const vuexLocal = new VuexPersistence(
  {
    storage: window.localStorage,
    // eslint-disable-next-line
    reducer: (state: any) => state.carritos
  }
)

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  },
  plugins: [vuexLocal.plugin]
})
